import React from 'react';

import { Checkbox } from 'components/uikit/Form/Checkbox/Checkbox';
import { Icon } from 'components/uikit/Icon/Icon';
import {
  ITEM_TYPE_DEFAULT,
  ITEM_TYPE_ICON,
  ITEM_TYPE_CHECKBOX,
  ITEM_ALIGN_CENTER,
  ITEM_SIZE_LARGE,
} from './ListItem.constants';
import * as S from './ListItem.styles';
import { useListItemPresenter } from './ListItem.presenter';

export const ListItem = ({
  type = ITEM_TYPE_DEFAULT,
  size = ITEM_SIZE_LARGE,
  id,
  title,
  description,
  subTitle,
  icon,
  align = ITEM_ALIGN_CENTER,
  leftSlot = null,
  rightSlot = null,
  checked,
  disabled,
  onClick,
  theme = 1,
  className,
}) => {
  const presenter = useListItemPresenter({ id, title, description, subTitle, checked, onClick });

  return (
    <S.Container
      align={align}
      type={type}
      onClick={presenter.itemClickHandler}
      className={className}
      theme={theme}
      size={size}
    >
      <S.MainContent align={align}>
        <S.LeftSlot type={type}>
          {leftSlot || (
            <>
              {type === ITEM_TYPE_CHECKBOX && (
                <Checkbox value={checked} onChange={() => {}} disabled={disabled} />
              )}
              {type === ITEM_TYPE_ICON && icon && <Icon Icon={icon} />}
            </>
          )}
        </S.LeftSlot>
        <S.ContentSlot>
          {description && <S.Description>{description}</S.Description>}
          <S.Title>{title}</S.Title>
          {subTitle && <S.SubTitle>{subTitle}</S.SubTitle>}
        </S.ContentSlot>
      </S.MainContent>
      <S.RightSlot align={align}>{rightSlot}</S.RightSlot>
    </S.Container>
  );
};
